import { DataEvents } from "@dhx/ts-data";
import { DataPage, DataStore } from "@xbs/muon";
import { IAction, IActionConfig, SpreadsheetEvents } from "../types";

export class ClearSheet implements IAction {
	public config: IActionConfig;
	private _data: any;
	private _store: DataStore;
	private _page: DataPage;

	constructor(config: IActionConfig) {
		this.config = config;
		this._store = config.dataStore;
	}

	do() {
		const { val, spreadsheet } = this.config;
		this._page = this._store.getPage(val);

		this._data = this._page ? this._page.serialize(true) : [];
        this._page.parse([]);
		(spreadsheet as any)._math.recalculate();
        spreadsheet.selection.setFocusedCell(spreadsheet.selection.getSelectedCell());
		(spreadsheet as any)._grid.paint();
	}

	undo() {
		const { spreadsheet } = this.config;
        this._page.parse(this._data)
		this._store.getStore().recalculate(true, this._page.getContext());
        spreadsheet.selection.setFocusedCell(spreadsheet.selection.getSelectedCell());
		(spreadsheet as any)._math.recalculate();
		(spreadsheet as any)._grid.paint();
	}
}
